import { mdiTimerOutline } from '@mdi/js'

export default {
  __name: 'ArticleCard',
  props: { article: Object, slug: String },
  setup(__props) {



return { __sfc: true,mdiTimerOutline }
}

}